import { MenuItem, TextField } from '@mui/material';
import { genders } from '../../../../../constants';
import { IGender } from '../../../../../Interfaces/IGender';

type GenderInputProps = {
  value: number;
  onChange: (value: number) => void;
};

export function GenderInput({ value, onChange }: GenderInputProps) {
  return (
    <TextField
      select
      fullWidth
      label='Geschlecht'
      size='small'
      value={value}
      required
      onChange={event => onChange(Number(event.target.value))}
    >
      {genders.map((gender: IGender) => (
        <MenuItem key={gender.idGender} value={gender.idGender}>
          {gender.Gender}
        </MenuItem>
      ))}
    </TextField>
  );
}
